import { Box, Tab, Tabs } from "@mui/material";
import React from "react";
import { useState } from "react";
import TabPanel from "../../components/admin/TabPanel";
import InviteProvider from "../../components/admin/InviteProvider";
import Header from "../../layouts/admin/AdminHeader";
import { ProviderTable } from "./ProviderTable";
import UserTable from "./UserTable"; // Add this import
import { ArchivedLocationTable } from "./ArchivedLocationTable";

function ManageProviders() {
  const [value, setValue] = useState(0);
  const [search, setSearch] = useState("");
  const [inviteSent, setInviteSent] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleInviteSent = () => {
    setInviteSent((prev) => !prev);
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  return (
    <>
      <Header pageTitle="Locations" />
      <div className="cardOuter">
        <div className="cardcontents">
          <Box sx={{ mt: 3 }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                className="butoontabdesigns"
                value={value}
                onChange={handleChange}
                indicatorColor="none"
              >
                <Tab
                  className={value === 0 ? "actived" : ""}
                  label="Provider/Location Listing"
                  id="tab-0"
                />
                <Tab
                  className={value === 1 ? "actived" : ""}
                  label="Create Provider/Location"
                  id="tab-1"
                />
                <Tab
                  className={value === 2 ? "actived" : ""}
                  label="User Listing"
                  id="tab-2"
                />
                <Tab
                  className={value === 3 ? "actived" : ""}
                  label="Archived Locations"
                  id="tab-3"
                />
              </Tabs>
              <TabPanel value={value} index={0}>
                <div className="searchBar">
                  <input
                    type="text"
                    autoComplete="off"
                    placeholder="Search"
                    value={search}
                    onChange={handleSearchChange}
                  />
                </div>
                <ProviderTable search={search.trim()} />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <InviteProvider
                  onInviteSent={handleInviteSent}
                  
                  onCancel={() => setValue(0)}
                  setValue={setValue}
                />
              </TabPanel>
              <TabPanel value={value} index={2}>
                <UserTable />
              </TabPanel>
              <TabPanel value={value} index={3}>
                <ArchivedLocationTable />
              </TabPanel>
            </Box>
          </Box>
        </div>
      </div>
    </>
  );
}

/** @type {import("@mui/material").SxProps} */
const styles = {
  iconColumn: {
    lineHeight: "normal",
  },
  iconColumnText: {
    fontSize: "0.9rem",
  },
  link: {
    textDecoration: "none",
    color: "black",
  },
};

export default ManageProviders;
